import { render } from "./FlatRatePlan.vue?vue&type=template&id=d8278328&scoped=true&ts=true"
import script from "./FlatRatePlan.vue?vue&type=script&lang=ts"
export * from "./FlatRatePlan.vue?vue&type=script&lang=ts"

import "./FlatRatePlan.vue?vue&type=style&index=0&id=d8278328&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8278328"]])

export default __exports__